query EmailChangeRequest($id: ID!) {
  newEmail: emailChangeRequest(id: $id)
}
